import ApiCall from "./ApiCall";
import { getAuthToken, getCurrentUser } from "./Helper";

export const setTranslationCookie = (languageCode) => {
  // Clear any existing cookies that might conflict (different paths or domains)
  const domains = [
    window.location.hostname,
    `.${window.location.hostname}`,
    "",
  ];

  domains.forEach((domain) => {
    document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;${domain ? ` domain=${domain};` : ""}`;
  });

  if (languageCode && languageCode !== "en") {
    const cookieValue = `/en/${languageCode}`;

    // Set for current domain and root path
    document.cookie = `googtrans=${cookieValue}; path=/`;

    // Also try with host domain to be safe, if not localhost
    const hostname = window.location.hostname;
    if (hostname !== "localhost" && !hostname.match(/^\d+\.\d+\.\d+\.\d+$/)) {
      document.cookie = `googtrans=${cookieValue}; domain=.${hostname}; path=/`;
    }
  }
};

export const ensureGoogleTranslateLoaded = () => {
  if (!document.getElementById("google_translate_element")) {
    const translateDiv = document.createElement("div");
    translateDiv.id = "google_translate_element";
    translateDiv.style.position = "absolute";
    translateDiv.style.top = "-9999px";
    translateDiv.style.left = "-9999px";
    document.body.appendChild(translateDiv);
  }

  window.googleTranslateElementInit = () => {
    if (window.google && window.google.translate) {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          autoDisplay: false,
        },
        "google_translate_element",
      );
    }
  };

  if (!document.querySelector('script[src*="translate.google.com"]')) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    document.body.appendChild(script);
  }
};

export const applyTranslationDynamically = (languageCode) => {
  try {
    if (languageCode && languageCode !== "en") {
      ensureGoogleTranslateLoaded();
    }

    const apply = (select) => {
      if (!select) return;
      select.value = languageCode || "en";

      // Use a more compatible way to trigger the change event
      let event;
      if (typeof Event === "function") {
        event = new Event("change", { bubbles: true, cancelable: true });
      } else {
        event = document.createEvent("Event");
        event.initEvent("change", true, true);
      }
      select.dispatchEvent(event);

      let inputEvent;
      if (typeof Event === "function") {
        inputEvent = new Event("input", { bubbles: true, cancelable: true });
      } else {
        inputEvent = document.createEvent("Event");
        inputEvent.initEvent("input", true, true);
      }
      select.dispatchEvent(inputEvent);
    };

    // Toggle toolbar class dynamically
    const showToolbar =
      localStorage.getItem("show_google_translate_toolbar") === "true";
    if (languageCode && languageCode !== "en" && showToolbar) {
      document.body.classList.add("show-translate-toolbar");
    } else {
      document.body.classList.remove("show-translate-toolbar");
    }

    // Retry checking for .goog-te-combo up to 10 times (every 500ms) if not found immediately
    let retries = 0;
    const findAndApply = () => {
      const select = document.querySelector(".goog-te-combo");
      if (select) {
        apply(select);
      } else if (retries < 10) {
        retries++;
        setTimeout(findAndApply, 500);
      }
    };

    findAndApply();
  } catch (error) {
    console.error("Error applying translation dynamically:", error);
  }
};

export const fetchTranslatedComment = async (commentData, currentUserId) => {
  if (!commentData) {
    return commentData;
  }

  const resolvedUserId = currentUserId || getCurrentUser()?.id;
  const commenterId = commentData.user?.id || commentData.user_id;
  if (
    commenterId &&
    resolvedUserId &&
    String(commenterId) === String(resolvedUserId)
  ) {
    return commentData;
  }

  try {
    const response = await ApiCall(
      "GET",
      `dreams/comment/${commentData.id}`,
      null,
      getAuthToken(),
    );
    if (response.data?.success && response.data?.data?.comment) {
      return response.data.data.comment;
    }
  } catch (error) {
    console.error("Failed to fetch translated comment:", error);
  }

  return commentData;
};
